export default "__VITE_ASSET__DFRPQ3qy__"